module.exports = __webpack_public_path__ + "static/media/no_image.b2017c6d.png";